import { render, staticRenderFns } from "./CampusLocationMap.vue?vue&type=template&id=79fe39d3&scoped=true&"
import script from "./CampusLocationMap.vue?vue&type=script&lang=ts&"
export * from "./CampusLocationMap.vue?vue&type=script&lang=ts&"
import style0 from "./CampusLocationMap.vue?vue&type=style&index=0&id=79fe39d3&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fe39d3",
  null
  
)

export default component.exports